module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-about-foobar"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 content fb-bg-light"
  }, [_c('h3', [_vm._v("What's going on?")]), _vm._v(" "), _c('p', [_vm._v("\n          You might be asking who's wasting time on this and what's the point ...? So ...\n        ")]), _vm._v(" "), _c('br'), _c('h4', [_vm._v("Who?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _c('h4', [_vm._v("Why?")]), _vm._v(" "), _c('p', [_vm._v("\n          It's simple really - during the past " + _vm._s(new Date().getFullYear() - 2005) + "+ years I've been programming and playing around the ITverse\n          and I discovered that I keep adding different foobars, whether it's foobars useful for security\n          purposes, Java development, data analysis or some of my ml trainings, into several projects that keep\n          growing beyond anything that could possibly be useful at this point.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          That's why I decided to create searchable, taggable library of these snippets and small complete solutions\n          that can help me use the data that I have ready already and maybe even help other people with their awesome\n          challenges getting through the stuff that I already went through.\n        ")]), _vm._v(" "), _c('br'), _c('h4', [_vm._v("So ... What?")]), _vm._v(" "), _c('p', [_vm._v("\n          Well ... You can find a collection of pretty much everything that I find interesting - my goal is to keep\n          adding at least several Foobars every week and so far it's going quite ok (even though there is still some\n          time that I should spend coding the site itself).\n        ")]), _vm._v(" "), _c('br'), _c('h5', [_vm._v("Topics Covered")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _c('h4', [_vm._v("Hit me up!")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:jakub@foobar.beer",
      "title": "jakub@foobar.beer"
    }
  }, [_vm._v("jakub@foobar.beer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Java")]), _vm._v(" "), _c('li', [_vm._v("Kotlin")]), _vm._v(" "), _c('li', [_vm._v("Freemarker")]), _vm._v(" "), _c('li', [_vm._v("SQL")]), _vm._v(" "), _c('li', [_vm._v("NoSQL (MongoDB, Hazelcast)")]), _vm._v(" "), _c('li', [_vm._v("Reverse engineering")]), _vm._v(" "), _c('li', [_vm._v("Locksport")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          HMU with anything you want! I am up for adding your own snippets (the administration interface is not yet public)."), _c('br'), _c('br'), _vm._v("\n          And definitely let me know if some of my snippets actually helped you solve your problems!"), _c('br'), _c('br'), _vm._v("\n          You can reach me at "), _c('a', {
    attrs: {
      "href": "mailto:jakub@foobar.beer",
      "title": "jakub@foobar.beer"
    }
  }, [_vm._v("jakub@foobar.beer")]), _vm._v(" - I'll be looking forward on the other side!\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4fafa5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/AboutFoobar.vue
// module id = 1850
// module chunks = 1